import logo from "./logo.svg";
import "./App.css";
import Main from "./pages/Main";
import Header from "./pages/Header";
import Footer from "./pages/Footer";
import hero from "./pages/hero";

function App() {
  return (
    <body>
      {/* <!-- ======= Mobile nav toggle button ======= --> */}
      <i className="bi bi-list mobile-nav-toggle d-xl-none"></i>

      <a
        href="#"
        className="back-to-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>
      <Main />
    </body>
  );
}

export default App;
